// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2MfiJ","rightAdornment":"Header_rightAdornment__2k2tg"};